import styled from 'styled-components';

// Components
import { Card } from 'top-component-library';

export const MessageCard = styled(Card)`
  .ant-card {
    &-body {
      padding: 0;
    }
  }
`;

export const StyledRichText = styled.div`
  p,
  p span,
  p span sup,
  p span sub,
  p span sup em,
  p strong {
    color: var(--color-neutral__body);
    font-family: var(--default-font);
    font-size: 0.875rem;
    &:last-child {
      margin-bottom: 0;
    }
  }
`;
